import { render, staticRenderFns } from "./BranchInfo.vue?vue&type=template&id=3bfcb4f2&scoped=true&"
import script from "./BranchInfo.vue?vue&type=script&lang=js&"
export * from "./BranchInfo.vue?vue&type=script&lang=js&"
import style0 from "./BranchInfo.vue?vue&type=style&index=0&id=3bfcb4f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfcb4f2",
  null
  
)

export default component.exports